import React, { useMemo } from 'react'
import { Redirect, Route, useLocation } from 'react-router-dom'
import routes from 'constants/router'
import { getMatchedRoute } from 'utils/findMatchedRoutes'
import { ROUTES } from 'constants/routes'
import LAYOUTS_MAP from 'layouts'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useAuthState } from 'modules/Auth/hooks/useAuthState'
import RouteGuard from 'modules/Auth/RouteGuard'
import RouteModuleRenderer from 'modules/Auth/RouteModuleRenderer'
import { AUTHORIZED_SHELL_I18N_NAMESPACES } from 'i18nProduct'
import { isPrivateAccess } from 'utils/routeAccess'

const NO_SHELL_I18N_NAMESPACES = []

const AppRouter = () => {
  const pathGen = useGeneratePathI18n()
  const location = useLocation()
  const { user, isAuthenticated } = useAuthState()

  const matchedRoute = useMemo(
    () => getMatchedRoute(routes, location.pathname),
    [location.pathname],
  )

  const isPrivateRoute = useMemo(
    () => isPrivateAccess(matchedRoute?.access),
    [matchedRoute],
  )

  const shellI18nNamespaces = useMemo(
    () =>
      user?.id && isPrivateRoute ? AUTHORIZED_SHELL_I18N_NAMESPACES : NO_SHELL_I18N_NAMESPACES,
    [user?.id, isPrivateRoute],
  )

  if (!matchedRoute) {
    return (
      <Redirect to={isAuthenticated ? pathGen(ROUTES.SERVICES) : pathGen(ROUTES.AUTH_LOGIN)} />
    )
  }

  const layoutKey = matchedRoute.layout ?? 'main'
  const LayoutComponent = LAYOUTS_MAP[layoutKey] ?? LAYOUTS_MAP.main
  const { component: RouteComponent = null, key: routeKey, path: routePath } = matchedRoute

  return (
    <LayoutComponent>
      <Route
        path={routePath}
        exact={matchedRoute.exact}
      >
        <RouteGuard route={matchedRoute}>
          <RouteModuleRenderer
            key={routeKey}
            routeKey={routeKey}
            routePath={routePath}
            RouteComponent={RouteComponent}
            shellI18nNamespaces={shellI18nNamespaces}
          />
        </RouteGuard>
      </Route>
    </LayoutComponent>
  )
}

export default AppRouter
